const router = {
  path: '/authLogin',
  name: 'AuthLogin',
  component: () => import('@/views/login/authLogin')
}
export default router



// WEBPACK FOOTER //
// ./src/router/authLogin.js